"use client";

import { Fragment } from "react";
import { FC } from "react";
import DatePicker from "react-datepicker";
import { Popover, Transition } from "@headlessui/react";
import { CalendarIcon } from "@heroicons/react/24/outline";
import DatePickerCustomDay from "components/DatePickerCustomDay";
import { changeDate } from "utils/changeDate";
import { useData } from "data/data-provider";
import { useLocation } from "react-router-dom";
import DatePickerCustomHeaderOneMonth from "components/DatePickerCustomHeaderOneMonth";

export interface RentalCarDatesRangeInputProps {
  className?: string;
  fieldClassName?: string;
  hasButtonSubmit?: boolean;
  isStatic?: boolean;
  showSingleMonth?: boolean;
}

const RentalCarDatesRangeInput: FC<RentalCarDatesRangeInputProps> = ({
  className = "",
  fieldClassName = "[ nc-hero-field-padding ] lg:p-0",
  isStatic,
  showSingleMonth,
}) => {
  const {
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    startTime,endTime
  } = useData();

  const onChangeDate = (dates: [Date | null, Date | null]) => {
    changeDate(
      dates,
      setStartDate,
      setEndDate, startTime,endTime
    );
  };
  const location = useLocation();
  const isCarDetailRoute = location.pathname === "/listing-car-detail";

  const renderInput = () => {
    return (
      <>
        <div
          className={`${
            isCarDetailRoute
              ? "text-[#4B5563]"
              : "md:text-neutral-300 text-black"
          }`}
        >
          <CalendarIcon className="w-5 h-5 lg:w-7 lg:h-7" />
        </div>
        <div className="flex-grow text-left">
          <span className="block xl:text-base text-[#121212]">
            {startDate?.toLocaleDateString("en-US", {
              month: "short",
              day: "2-digit",
            }) || "Add dates"}
            {endDate
              ? " - " +
                endDate?.toLocaleDateString("en-US", {
                  month: "short",
                  day: "2-digit",
                })
              : ""}
          </span>
          <span className="block mt-1 text-xs text-[#121212] leading-none font-light">
            {"Pick up - Drop off"}
          </span>
        </div>
      </>
    );
  };

  return (
    <>
      <Popover
        className={`RentalCarDatesRangeInput z-20 relative flex ${className}`}
      >
        {({ open }) => (
          <>
            <div
              className={`flex-1 z-10 flex items-center focus:outline-none ${
                open && !isStatic ? "" : ""
              }`}
            >
              <Popover.Button
                className={`flex-1 z-10 flex relative ${fieldClassName} items-center space-x-3 focus:outline-none `}
                onClickCapture={() => document.querySelector("html")?.click()}
              >
                {renderInput()}

                {/* {!isStatic && startDate && open && (
                  <ClearDataButton
                    onClick={() => onChangeDate([startDate, endDate])}
                  />
                )} */}
              </Popover.Button>
            </div>

            {!isStatic && open && (
              <div className="h-8 absolute self-center top-1/2 -translate-y-1/2 z-0 -left-0.5 right-1 "></div>
            )}

            {!isStatic && open && (
              <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1"
              >
                <Popover.Panel className="absolute left-1/2 z-10 mt-3 top-full w-screen max-w-sm -translate-x-1/2 transform px-4 sm:px-0 lg:max-w-3xl">
                  <div className="overflow-hidden rounded-3xl shadow-lg ring-1 ring-black ring-opacity-5 dark:bg-[#414141F2] p-8">
                    <DatePicker
                      selected={startDate}
                      onChange={onChangeDate}
                      startDate={startDate}
                      endDate={endDate}
                      selectsRange
                      monthsShown={1}
                      showPopperArrow={false}
                      inline
                      minDate={new Date()} // Disable all dates before today
                      renderCustomHeader={(p) => (
                        <DatePickerCustomHeaderOneMonth {...p} />
                      )}
                      renderDayContents={(day, date) => (
                        <DatePickerCustomDay dayOfMonth={day} date={date} />
                      )}
                    />
                  </div>
                </Popover.Panel>
              </Transition>
            )}
          </>
        )}
      </Popover>
    </>
  );
};

export default RentalCarDatesRangeInput;
